function seededRandom(seed) {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return (s - 1) / 2147483646;
  };
}

function generateTrades() {
  const rand = seededRandom(42);
  const trades = [];
  let id = 1;

  const startDate = new Date('2024-05-24T00:00:00');
  const endDate = new Date('2025-03-21T00:00:00');
  let basePrice = 17850;

  const current = new Date(startDate);

  while (current <= endDate) {
    const day = current.getDay();
    if (day === 0 || day === 6) {
      current.setDate(current.getDate() + 1);
      continue;
    }

    const tradesPerDay = Math.floor(rand() * 4) + 5;
    const hours = [9, 10, 11, 12, 13, 14, 15];

    const usedHours = [];
    for (let i = 0; i < tradesPerDay && i < hours.length; i++) {
      let h;
      do { h = hours[Math.floor(rand() * hours.length)]; } while (usedHours.includes(h));
      usedHours.push(h);
    }
    usedHours.sort((a, b) => a - b);

    for (const h of usedHours) {
      const minute = Math.floor(rand() * 55) + 1;
      const ampm = h < 12 ? 'AM' : 'PM';
      const displayH = h > 12 ? h - 12 : h;
      const timeStr = `${String(displayH).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${ampm}`;

      const isWin = rand() < 0.734;
      const magnitude = 60 + rand() * 160;
      const profit = isWin ? magnitude : -magnitude;
      const rounded = Math.round(profit * 4) / 4;

      const entry = basePrice + (rand() - 0.5) * 40;
      const exit = entry + (rounded / 5);

      const y = current.getFullYear();
      const m = String(current.getMonth() + 1).padStart(2, '0');
      const d = String(current.getDate()).padStart(2, '0');

      trades.push({
        id: id++,
        date: `${y}-${m}-${d}`,
        time: timeStr,
        entryPrice: Math.round(entry * 4) / 4,
        exitPrice: Math.round(exit * 4) / 4,
        profit: rounded,
      });
    }

    basePrice += (rand() - 0.45) * 30;
    if (basePrice < 17200) basePrice = 17200 + rand() * 100;
    if (basePrice > 21500) basePrice = 21500 - rand() * 100;

    current.setDate(current.getDate() + 1);
  }

  return trades;
}

export const tradeHistory = generateTrades();
